import { cn } from '@/lib/utils';
import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { moneyListDirection } from '@/features/dashboard/bookingChanges/utils/money.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import { balanceHeading } from './changePackageCopy.ts';

interface ClientAcceptanceBalancePanelProps
  extends React.HTMLAttributes<HTMLDivElement> {
  balance: MoneyValueDto[];
  /** Zdanie tłumaczące, jak kwota wchodzi w harmonogram. */
  settlementDescription: string;
}

/**
 * Blok kwoty na stronie klienta. Kwota stoi bez znaku — kierunek niesie sam
 * nagłówek, bo zapisujący czyta „ile dopłacam”, a nie bilans paczki.
 */
const ClientAcceptanceBalancePanel = ({
  balance,
  settlementDescription,
  className,
  ...props
}: ClientAcceptanceBalancePanelProps) => (
  <div
    className={cn(
      'rounded-[11px] border border-neutral-200 bg-neutral-50 px-[18px] py-4',
      className,
    )}
    {...props}
  >
    <div className="flex items-baseline">
      <span className="text-[15px] font-bold text-ink">
        {balanceHeading(balance)}
      </span>
      <span className="ml-auto text-2xl font-extrabold tabular-nums text-ink">
        {/* Kwota bez znaku, bo kierunek niesie nagłówek — chyba że paczka
            w jednej walucie dopłaca, a w drugiej zwraca; wtedy nagłówka nie ma
            i znak musi zostać przy liczbie. */}
        <MoneyAmountList
          values={balance}
          variant={moneyListDirection(balance) === null ? 'signed' : 'absolute'}
        />
      </span>
    </div>
    <p className="mt-2 text-pretty text-sm text-neutral-600">
      {settlementDescription}
    </p>
  </div>
);

export default ClientAcceptanceBalancePanel;
